export type ConnectState = {
  allowRemoteWsHosts: Record<string, boolean>;
  matchmakerURL?: string;
  socialURL?: string;
  apiURL?: string;
  editorURL?: string;
};

export type ConnectTargetState = {
  allowHosts: string[];
  matchmakerURL: string;
  socialURL: string;
  apiURL: string;
  editorURL: string;
};

const connectState: ConnectState = {
  allowRemoteWsHosts: {},
};

export function getConnectState(): ConnectState {
  return connectState;
}

export function setConnectTargetState(target: ConnectTargetState): ConnectState {
  connectState.matchmakerURL = target.matchmakerURL;
  connectState.socialURL = target.socialURL;
  connectState.apiURL = target.apiURL;
  connectState.editorURL = target.editorURL;
  connectState.allowRemoteWsHosts = {};
  for (const host of target.allowHosts) {
    connectState.allowRemoteWsHosts[host] = true;
  }
  return connectState;
}

export function resetConnectState(): ConnectState {
  delete connectState.matchmakerURL;
  delete connectState.socialURL;
  delete connectState.apiURL;
  delete connectState.editorURL;
  connectState.allowRemoteWsHosts = {};
  return connectState;
}

export function isAllowedRemoteWsHost(hostname: string): boolean {
  const allowedHosts = connectState.allowRemoteWsHosts;
  return (
    !!allowedHosts[hostname] ||
    Object.keys(allowedHosts).some(
      (host) => allowedHosts[host] && hostname.endsWith("." + host),
    )
  );
}